const constantUtils = {};
//
constantUtils.ACTION_ADD = "add"; // Don't Change Leter Case Type
constantUtils.ACTION_EDIT = "edit"; // Don't Change Leter Case Type
constantUtils.ACTION_VIEW = "view"; // Don't Change Leter Case Type
constantUtils.ACTION_DELETE = "delete"; // Don't Change Leter Case Type
//
constantUtils.COUNTRYCODE_BRAZIL = "+55";
//
constantUtils.CONST_ASSIGNINSTANT = "ASSIGNINSTANT";
constantUtils.CONST_ASSIGNSCHEDULE = "ASSIGNSCHEDULE";
//
constantUtils.CONST_DEVELOPMENT = "DEVELOPMENT";
constantUtils.CONST_PRODUCTION = "PRODUCTION";
//
constantUtils.CONST_SHORTEST = "SHORTEST";
constantUtils.CONST_NEAREST = "NEAREST";
constantUtils.CONST_COMPETITIVE = "COMPETITIVE";
constantUtils.CONST_ADAPTIVE = "ADAPTIVE";
//
constantUtils.CONST_ZERVXSERVICES = "ZERVXSERVICES";
constantUtils.CONST_GENERALSETTING = "GENERALSETTING";
constantUtils.CONST_MAPSETTING = "MAPSETTING";
constantUtils.CONST_FIREBASESETTING = "FIREBASESETTING";
constantUtils.CONST_REGISTRATIONSETTING = "REGISTRATIONSETTING";
constantUtils.CONST_AIRPORTTRANSFERSETTING = "AIRPORTTRANSFERSETTING";
constantUtils.CONST_CALLCENTER = "CALLCENTER";
constantUtils.CONST_HEATMAP = "HEATMAP";
constantUtils.CONST_ALGORITHM = "ALGORITHM";
constantUtils.CONST_SERVICETYPE = "SERVICETYPE";
constantUtils.CONST_DISPATCH = "DISPATCH";
//
constantUtils.CONST_GENDER = "GENDER";
constantUtils.CONST_WEEKDAYS = "WEEKDAYS";
constantUtils.CONST_FUELTYPE = "FUELTYPE";
//
constantUtils.CONST_OPERATORS = "OPERATORS";
constantUtils.CONST_HUBS = "HUBS";
constantUtils.CONST_HUBSEMPLOYEE = "HUBSEMPLOYEE";
constantUtils.CONST_OPERATORSROLE = "OPERATORSROLE";
//
constantUtils.CONST_HUBSPRIVILEGES = "HUBSPRIVILEGES";
constantUtils.CONST_HUBSEMPLOYEEPRIVILEGES = "HUBSEMPLOYEEPRIVILEGES";
constantUtils.CONST_COORPERATEPRIVILEGES = "COORPERATEPRIVILEGES";
constantUtils.CONST_OFFICEPRIVILEGES = "OFFICEPRIVILEGES";
constantUtils.CONST_ADMINPRIVILEGES = "ADMINPRIVILEGES";
constantUtils.CONST_DEVELOPERPRIVILEGES = "DEVELOPERPRIVILEGES";
// notification Types
constantUtils.CONST_PUSH = "PUSH";
constantUtils.CONST_EMAIL = "EMAIL";
constantUtils.CONST_SMS = "SMS";
constantUtils.CONST_CALL = "CALL";
constantUtils.CONST_NOTIFICATION = "NOTIFICATION";
constantUtils.CONST_NOTIFICATIONTIME = "NOTIFICATIONTIME";
constantUtils.CONST_NOTIFICATIONSETUP = "NOTIFICATIONSETUP";
constantUtils.CONST_FORCEQUIT = "FORCEQUIT";
// Maps
constantUtils.CONST_GOOGLE = "GOOGLE";
constantUtils.CONST_BING = "BING";
constantUtils.CONST_TOMTOM = "TOMTOM";
constantUtils.CONST_GEOAPIFY = "GEOAPIFY";
constantUtils.CONST_LOCATIONIQ = "LOCATIONIQ";
constantUtils.CONST_GBETA = "GBETA";
constantUtils.CONST_MAPBOX = "MAPBOX";
// Email
constantUtils.CONST_GMAIL = "GMAIL";
constantUtils.CONST_BREVO = "BREVO";
constantUtils.CONST_SENDGRID = "SENDGRID";
constantUtils.CONST_MAILCHIMP = "MAILCHIMP";
// NOTICICATION CATEGORIES
constantUtils.CONST_ALPHABETICALORDER = "ALPHABETICALORDER";
constantUtils.CONST_CITY = "CITY";
constantUtils.CONST_ONLINE = "ONLINE";
constantUtils.CONST_OFFLINE = "OFFLINE";
constantUtils.CONST_CUSTOM = "CUSTOM";

// COMMON FOR FULL APP
constantUtils.CONST_USER = "USER";
constantUtils.CONST_PROFESSIONAL = "PROFESSIONAL";
//
constantUtils.CONST_GET = "GET";
constantUtils.CONST_TRACK = "TRACK";
//
constantUtils.CONST_ASCENDING = "ASCENDING";
constantUtils.CONST_DESCENDING = "DESCENDING";

//  PAYMENT TYPES
constantUtils.CONST_CARD = "CARD";
constantUtils.CONST_CASH = "CASH";
constantUtils.CONST_WALLET = "WALLET";
constantUtils.CONST_POS = "POS";
constantUtils.CONST_PIX = "PIX";

// PAYOUTOPTIONS
constantUtils.CONST_DISPLAYINFO = "DISPLAYINFO";
constantUtils.CONST_STANDARD = "STANDARD";
constantUtils.CONST_NORMAL = "NORMAL";

//
constantUtils.CONST_NEW = "NEW";
constantUtils.CONST_ACTIVE = "ACTIVE";
constantUtils.CONST_INACTIVE = "INACTIVE";
constantUtils.CONST_ARCHIEVE = "ARCHIEVE";
constantUtils.CONST_RESTORE = "RESTORE";
constantUtils.CONST_ATTENDED = "ATTENDED";
constantUtils.CONST_DELETE = "DELETE";
constantUtils.CONST_INCOMPLETE = "INCOMPLETE";
constantUtils.CONST_CLOSED = "CLOSED";
constantUtils.CONST_DROPDOWN = "DROPDOWN";
constantUtils.CONST_BLOCKED = "BLOCKED";
constantUtils.CONST_UNBLOCKED = "UNBLOCKED";
constantUtils.CONST_CORPORATE = "CORPORATE";
//
constantUtils.CONST_WEEKLY = "WEEKLY";
constantUtils.CONST_MONTHLY = "MONTHLY";
constantUtils.CONST_YEARLY = "YEARLY";

// SMS Providers
constantUtils.CONST_AFRO = "AFRO";
constantUtils.CONST_FIREBASE = "FIREBASE";
constantUtils.CONST_TWILIO = "TWILIO";
constantUtils.CONST_WHATSUP = "WHATSUP";
constantUtils.CONST_SENDIFY = "SENDIFY";
constantUtils.CONST_TUNISIESMS = "TUNISIESMS";
constantUtils.CONST_BEEMSMS = "BEEMSMS";
constantUtils.CONST_CLICKATELL = "CLICKATELL";
constantUtils.CONST_TELESIGN = "TELESIGN";
constantUtils.CONST_VONAGE = "VONAGE";
constantUtils.CONST_INFOBIP = "INFOBIP";
constantUtils.CONST_TERMII = "TERMII";
//
constantUtils.CONST_SOS = "SOS";
constantUtils.CONST_EMERGENCY = "EMERGENCY";
// Roles
constantUtils.CONST_ADMIN = "ADMIN";
constantUtils.CONST_DEVELOPER = "DEVELOPER";
constantUtils.CONST_COORPERATEOFFICE = "COORPERATEOFFICE";
constantUtils.CONST_CORPORATEOFFICER = "CORPORATEOFFICER";

//
constantUtils.CONST_STARTED = "STARTED";
constantUtils.CONST_ARRIVED = "ARRIVED";
constantUtils.CONST_ACCEPTED = "ACCEPTED";
constantUtils.CONST_ENDED = "ENDED";
constantUtils.CONST_ASSIGN = "ASSIGN";
constantUtils.CONST_FORCEASSIGN = "FORCEASSIGN";
constantUtils.CONST_AWAITING = "AWAITING";
constantUtils.CONST_EXPIRED = "EXPIRED";
constantUtils.CONST_ACTIVITY = "ACTIVITY";
constantUtils.CONST_REPORT = "REPORT";
constantUtils.CONST_PENDING = "PENDING";
constantUtils.CONST_FAILED = "FAILED";
constantUtils.CONST_PARTIAL = "PARTIAL";
//--------------------
constantUtils.CONST_TELEPORT = "TELEPORT";
constantUtils.CONST_NONE = "NONE";
constantUtils.CONST_TRIPS = "TRIPS";
constantUtils.CONST_PACKAGES = "PACKAGES";
constantUtils.CONST_SHIFTINGS = "SHIFTINGS";
constantUtils.CONST_ATOZ = "ATOZ";
constantUtils.CONST_EATS = "EATS";
constantUtils.CONST_ESSENTIALMART = "ESSENTIALMART";
constantUtils.CONST_RENTALS = "RENTALS";
constantUtils.CONST_PARKING = "PARKING";
constantUtils.CONST_SECUREME = "SECUREME";
constantUtils.CONST_DAILYTRIP = "DAILYTRIP";
//
constantUtils.CONST_ADMINISTRATORS = "ADMINISTRATORS";
//
constantUtils.CONST_MILES = "MILES";
constantUtils.CONST_MILES_VALUE = 1610;
constantUtils.CONST_KM = "KM";
constantUtils.CONST_KM_VALUE = 1000;
// Dashboard
constantUtils.CONST_ALL = "ALL";
constantUtils.CONST_INSTANT = "INSTANT";
constantUtils.CONST_SCHEDULE = "SCHEDULE";
constantUtils.CONST_CANCELLED = "CANCELLED";

// Rides Category
constantUtils.CONST_RIDE = "RIDE";
constantUtils.CONST_INTERCITYRIDE = "INTERCITYRIDE";
constantUtils.CONST_PICKUPOUTSIDERIDE = "PICKUPOUTSIDERIDE";
constantUtils.CONST_DROPOUTSIDERIDE = "DROPOUTSIDERIDE";
constantUtils.CONST_PICKUPANDDROPOUTSIDERIDE = "PICKUPANDDROPOUTSIDERIDE";
constantUtils.CONST_CORPORATERIDE = "CORPORATERIDE";
constantUtils.CONST_SHARERIDE = "SHARERIDE";
//
constantUtils.CONST_DELIVERY = "DELIVERY";
//
constantUtils.CONST_BONOUS = "BONOUS";
constantUtils.CONST_GUARANTEE = "GUARANTEE";
constantUtils.CONST_DAILY = "DAILY";
constantUtils.CONST_CAMPAIGN = "CAMPAIGN";
//
constantUtils.CONST_FLAT = "FLAT";
constantUtils.CONST_PERCENTAGE = "PERCENTAGE";
//
constantUtils.CONST_PACKAGEDOCUMENTS = "PACKAGEDOCUMENTS";
constantUtils.CONST_PROFILEDOCUMENTS = "PROFILEDOCUMENTS";
constantUtils.CONST_DRIVERDOCUMENTS = "DRIVERDOCUMENTS";
constantUtils.CONST_VEHICLEDOCUMENTS = "VEHICLEDOCUMENTS";
//
constantUtils.CONST_PACKAGESETTING = "PACKAGESETTING";
constantUtils.CONST_BLOCKPROFESSIONALSETUP = "BLOCKPROFESSIONALSETUP";
//
constantUtils.CONST_COUPON = "COUPON";
//
constantUtils.CONST_LOCATION = "LOCATION";
constantUtils.CONST_DIRECTION = "DIRECTION";
constantUtils.CONST_AUTOCOMPLETE = "AUTOCOMPLETE";
constantUtils.CONST_PLACE = "PLACE";
constantUtils.CONST_SNAP = "SNAP";
//
constantUtils.CONST_ELECTRIC = "ELECTRIC";
constantUtils.CONST_NON_ELECTRIC = "NONELECTRIC";
//
constantUtils.CONST_COMMON = "COMMON";
constantUtils.CONST_OTP = "OTP";
constantUtils.CONST_PROMOTION = "PROMOTION";
//
constantUtils.CONST_VERIFIED = "VERIFIED";
constantUtils.CONST_UNVERIFIED = "UNVERIFIED";
constantUtils.CONST_REJECTED = "REJECTED";
constantUtils.CONST_APPROVED = "APPROVED";
constantUtils.CONST_UPLOADED = "UPLOADED";
//
constantUtils.CONST_LANDINGPAGE = "LANDINGPAGE";
//
constantUtils.CONST_CREDIT = "CREDIT";
constantUtils.CONST_DEBIT = "DEBIT";
constantUtils.CONST_INCENTIVE = "INCENTIVE";
constantUtils.CONST_PAYMENTGATEWAY = "PAYMENTGATEWAY";
constantUtils.CONST_SMSSETTING = "SMSSETTING";
//
constantUtils.CONST_INCREASE = "INCREASE";
constantUtils.CONST_DECREASE = "DECREASE";
//
constantUtils.CONST_MANUAL = "MANUAL";
constantUtils.CONST_AUTOMATED = "AUTOMATED";
//
constantUtils.CONST_STRIPE = "STRIPE";
constantUtils.CONST_TEYA = "TEYA";
constantUtils.CONST_PEACH = "PEACH";
constantUtils.CONST_PAYSTACK = "PAYSTACK";
constantUtils.CONST_MONERIS = "MONERIS";
constantUtils.CONST_MERCADOPAGO = "MERCADOPAGO";
constantUtils.CONST_RAZORPAY = "RAZORPAY";
constantUtils.CONST_FLUTTERWAVE = "FLUTTERWAVE";
//
constantUtils.CONST_PASSENGERTYPE = "PASSENGERTYPE";
constantUtils.CONST_LUGGAGETYPE = "LUGGAGETYPE";
constantUtils.CONST_WATERBOTTLETYPE = "WATERBOTTLETYPE";
constantUtils.CONST_LANGUAGE = "LANGUAGE";
//
constantUtils.CONST_TOLL = "TOLL";
constantUtils.CONST_AIRPORT = "AIRPORT";
constantUtils.CONST_TRANSACTION = "TRANSACTION";
constantUtils.CONST_VEHICLE = "VEHICLE";
constantUtils.CONST_VEHICLESTATUS = "VEHICLESTATUS";
//
constantUtils.CONST_MANDATORY = "MANDATORY";
constantUtils.CONST_OPTIONAL = "OPTIONAL";
constantUtils.CONST_SKIP = "SKIP";
//
constantUtils.CONST_REVIEWCOMMENTS = "REVIEWCOMMENTS";
//
constantUtils.CONST_REWARDPOINT = "REWARDPOINT";
constantUtils.CONST_REDEEMREWARDPOINT = "REDEEMREWARDPOINT";
//
constantUtils.CONST_A_TO_B = "A_TO_B";
constantUtils.CONST_B_TO_A = "B_TO_A";
constantUtils.CONST_BOTH = "BOTH";
//report
constantUtils.CONST_TRIPS_ACTIVITY = "TRIPS_ACTIVITY";
constantUtils.CONST_USER_TRIPS_ACTIVITY = "USER_TRIPS_ACTIVITY";
constantUtils.CONST_USERS_REPORTS = "USERS_REPORT";
constantUtils.CONST_PROFESSIONAL_REPORT = "PROFESSIONAL_REPORT";
constantUtils.CONST_DRIVER_TRIPS_ACTIVITY = "DRIVER_TRIPS_ACTIVITY";
constantUtils.CONST_REVENUE = "REVENUE";
constantUtils.CONST_ZONE = "ZONE";
constantUtils.CONST_SURGE_PRICING = "SURGE_PRICING";
constantUtils.CONST_COMPLETED = "COMPLETED";
constantUtils.CONST_PROCESSING = "PROCESSING";
//--------------------------------
module.exports = constantUtils;
